import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

// As paginas antigas do Work (/oxe-tech-work, /oxetechwork, /oxetechwork/vaga/:id)
// continuam publicas para visitante e empresa. Aluno logado vai para o modulo
// dentro do painel. `destino(props)` monta a URL nova (ex.: preserva o id da vaga).
export default function redirecionaAluno(Componente, destino) {
  function ComRedirect(props) {
    const signed = useSelector((s) => s?.auth?.signed);
    const profile = useSelector((s) => s?.user?.profile?.dataValues || s?.user?.profile);
    const ehAluno = Boolean(signed && profile?.cpf && !profile?.razao_social);
    if (ehAluno) return <Redirect to={destino(props)} />;
    return <Componente {...props} />;
  }
  ComRedirect.displayName = `RedirecionaAluno(${Componente.displayName || Componente.name || "Pagina"})`;
  return ComRedirect;
}
